import { createSelector } from "@reduxjs/toolkit"; // or "reselect"

import { BillCache } from "pwapi/models/BillCache";

import { RootState } from "store/store";

export const selectAutoCptCodesEnabled = createSelector(
  [
    (state: RootState) => state.caseDetail.bill_caches,
    (state: RootState) => state.caseDetail.billing_date,
    (state: RootState) => state.caseDetail.has_biller_result_without_bill,
  ],
  (bill_caches, billing_date, has_biller_result_without_bill) =>
    !!bill_caches?.filter(
      (b) => b.generate_integration_bill && b.type !== BillCache.type.TEST
    )?.length &&
    !billing_date &&
    !has_biller_result_without_bill
);
